import { useContext, useEffect } from 'react';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import { IconButton, Skeleton } from '@mui/material';
import { useObjectAccessModal } from '@/components/ObjectAccess';
import { AppThemingContext } from '@trinity/chat-components/containers/AppTheming/Context.js';
import { useFetchObjectAccess, useObjectAccessState } from '@/containers/ObjectAccess/hooks';
import { ObjectAccessContainer } from '@/containers/ObjectAccess/ObjectAccessContainer';
import { ProjectDetailsContext, ProjectStateLoadingContext } from './Context';
import styles from './style/ProjectHeader.module.css';


export const ManageAccessButton = () => {
  const isLoading = useContext(ProjectStateLoadingContext);
  const ctx = useContext(ProjectDetailsContext);
  const [toggleAccessModal, ObjectAccessModal] = useObjectAccessModal();

  if (isLoading || !ctx.query?.data?.object) {
    return (
      <Skeleton
        height={40}
        width={40}
        variant="circular" />
    );
  }

  const handleClick = () => {
    toggleAccessModal();
  };

  return (
    <>
      <ObjectAccessContainer
        objectId={ctx.query.data.object.id}
        workspaceId={ctx.query.data.object.workspaceId}>
        <div className={styles.manageAccessWrapper}>
          <IconButton
            onClick={handleClick}
            className={styles.manageAccessBtn}
            aria-label="Manage project access">
            <GroupsOutlinedIcon style={{ fontSize: '30px' }} />
          </IconButton>
          <AccessCountDisplay />
        </div>
        <ObjectAccessModal />
      </ObjectAccessContainer>
    </>
  );
};

const AccessCountDisplay = () => {
  const [state] = useObjectAccessState();
  const fetchAccess = useFetchObjectAccess();
  const { palette, theme: wl } = useContext(AppThemingContext);

  // Fetch access data when component mounts
  useEffect(() => {
    if (!state.initial.length && fetchAccess) {
      fetchAccess();
    }
  }, [fetchAccess, state.initial.length]);

  const userCount = state.initial?.length || 0;

  const counterStyle = wl?.enabled ? {
    backgroundColor: palette.primary.main,
    color: palette.primary.text,
  } : {};

  return <span className={styles.accessCount} style={counterStyle}>{userCount}</span>;
};